function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   height: ", ";\n   vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var TopNavLogo = styled.img(_templateObject(), function (_ref) {
  var height = _ref.height;
  return height;
});
TopNavLogo.defaultProps = {
  height: '40px'
};
export { TopNavLogo };